import React, { Suspense, useEffect } from 'react';
import { useQuery } from "react-query";
import * as apiClient from "../api-client";
// Import the CSS
import '../index.css';
import Loader from '../components/LoaderComponent';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import FAQLastMinute from '../components/HolidayFAQs/LastMinuteFaq';
import BlogSliderType from '../components/Blogs/BlogSliderType';
import HolidayTypeHotelsList from '../components/HolidayTypeHotelList';
import Slider1 from "../components/CountrySliders/Maldives/LastMinuteSlider";
import Slider2 from "../components/CountrySliders/Mauritius/LastMinuteSlider";
import HotelSliderSkeleton from '../components/Skeletons/HotelSliderSkeleton';
import ReadMoreLines from '../components/ReadMoreLines';

// Lazy load the components
// const LazyLatestDestinationCard = React.lazy(() => import('../components/LastestDestinationCard'));
const LazyWhyChoose = React.lazy(() => import('../components/WhyChoose/LastMinute'));
const LazyVacationTypes = React.lazy(() => import('../components/Home/VacationTypes'));

const PageLastminute = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: hotels } = useQuery("fetchAllInclusiveHotels", apiClient.fetchHotels);

  // const [isExpanded, setIsExpanded] = useState(false);
  // const toggleText = () => setIsExpanded(!isExpanded);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Last Minute Holidays & Deals | Halo Holidays</title>
          <meta name="description" content="Escape the ordinary with Halo Holidays' last minute deals. Discover incredible savings on beach holidays, city breaks, and all-inclusive resorts." />
          {/* <meta name="keywords" content="travel, hotels, holidays, deals, holiday packages" /> */}
        </Helmet>
      </HelmetProvider>

      <section className="max-h-640 md:min-h-0 lg:min-h-0 my-8">
        <hr className="mb-10" />
        <h2 className="text-2xl font-semibold items-center justify-center flex mt-10">More reasons to choose us</h2>
        <Suspense fallback={<Loader />}>
          <LazyWhyChoose />
        </Suspense>
        <hr className="mb-10 mt-10" />
      </section>

      <section className="mx-4 my-4 md:mx-0 md:my-0">

        <div className='mt-2 mb-4'>
          <h1 className="text-2xl font-semibold">Last Minute Holidays</h1>
          <ReadMoreLines mobileMaxRows={2} desktopMaxRows={2}>
            <p className="text-black md:mb-1 md:mt-2">
              Craving a spontaneous getaway? Halo Holidays is here to make your dream of a last-minute holiday a reality! With our incredible selection of last minute holidays, you can enjoy unbeatable savings on flights, hotels, and all-inclusive packages to some of the world’s most exciting destinations. Whether you’re yearning for the sun-kissed beaches of the Caribbean, the vibrant energy of Europe’s cities, or the peaceful serenity of a mountain retreat, our last-minute deals offer the perfect escape without the long planning.
              <br /><br />
              Why wait for the perfect moment? The adventure of a lifetime is just a click away. Pack your bags, embrace the thrill of spontaneity, and let us whisk you away to your dream destination for a last-minute holiday you’ll never forget.
            </p>
            <br />
            <h2 className='text-xl font-semibold'>Luxury at a Steal: Last Minute Holiday Deals on Handpicked Resorts</h2>
            <p className='text-black'>
              Unwind in luxury for less with our exclusive last minute holiday deals on handpicked resorts. Whether you're dreaming of a secluded beachfront villa, a chic city hotel, or a family-friendly all-inclusive resort, we have the perfect destination for you. Indulge in unlimited food and drinks, thrilling activities, and world-class amenities, all while saving big. Whether you’re planning a romantic escape, a family adventure, or a solo retreat, our last-minute deals ensure that your spontaneous getaway will be filled with luxury and unforgettable memories.
            </p>
            <br />
            <h2 className='text-xl font-semibold'>More Than Just Last Minute – Explore Our Full Range of Holidays</h2>
            <p className='text-black'>
              Looking for something beyond last-minute deals? Halo Holidays offers a wide array of holidays for every traveler. Planning a family getaway? Our family holidays offer fun for all ages, from kid-friendly resorts to adventurous tours. Dreaming of a romantic retreat? Our couple holidays feature intimate settings and unforgettable experiences to help you reconnect. Solo travelers can also find inspiration with our solo holiday packages, offering exciting adventures and moments of self-discovery.
              <br /><br />
              No matter your travel style or destination of choice, Halo Holidays has the perfect holiday waiting for you. Let our expert travel advisors help you plan your next adventure – whether it's a last-minute escape or a well-planned dream holiday!
            </p>
          </ReadMoreLines>
        </div>

        <Suspense fallback={<Loader />}>
          <section>
            <div className='mt-6 -mb-2 md:mt-0 md:mb-2'>
              <h2 className="text-xl font-semibold">Maldives Holiday Deals</h2>
            </div>
            <div className="hidden md:block lg:block lgx2:block">
              {hotels && (
                <HolidayTypeHotelsList hotels={hotels} holidayType="Last Minute" holidayCountry="Maldives" />
              )}
            </div>
            <Suspense fallback={<HotelSliderSkeleton />}>
              <div className="container md:hidden lg:hidden">
                <Slider1 hotels={hotels ?? []} />
              </div>
            </Suspense>
          </section>
        </Suspense>

        <Suspense fallback={<Loader />}>
          <section>
            <div className='md:mt-4 -mb-2 md:mb-2'>
              <h2 className="text-xl font-semibold">Mauritius Holiday Deals</h2>
            </div>
            <div className="hidden md:block lg:block lgx2:block">
              {hotels && (
                <HolidayTypeHotelsList hotels={hotels} holidayType="Last Minute" holidayCountry="Mauritius" />
              )}
            </div>
            <Suspense fallback={<HotelSliderSkeleton />}>
              <div className="container md:hidden lg:hidden">
                <Slider2 hotels={hotels ?? []} />
              </div>
            </Suspense>
          </section>
        </Suspense>

        <FAQLastMinute />

        {/* <Suspense fallback={<Loader />}>
      <h2 className="text-3xl font-bold">Latest All Inclusive Destinations</h2>
      <p>Most recent all-inclusive destinations added by our hosts</p>
      </Suspense> */}
        {/* Displaying the top row hotels */}
        {/* <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
        {topRowHotels.map((hotel) => (
          <Suspense fallback={<Loader />} key={hotel._id}>
            <LazyLatestDestinationCard hotel={hotel} />
          </Suspense>
        ))}
      </div>
       */}
        {/* Displaying the bottom row hotels */}
        {/* <div className="grid md:grid-cols-3 gap-4">
        {bottomRowHotels.map((hotel) => (
          <Suspense fallback={<Loader />} key={hotel._id}>
            <LazyLatestDestinationCard hotel={hotel} />
          </Suspense>
        ))}
      </div> */}

        <Suspense fallback={<Loader />}>
          <div className='p-4 md:p-0 md:mt-12 md:mb-12'>
            <LazyVacationTypes />
          </div>
        </Suspense>

        <section className='p-4 md:p-0'>
          <h2 className='text-2xl font-semibold mb-4'>Related Blogs</h2>
          <BlogSliderType blogType='island_paradise' />
        </section>

        {/* <Suspense fallback={<Loader />}>
      <h2 className="text-3xl font-bold">More All Inclusive Destinations</h2>
      <p>Explore more all-inclusive destinations</p>
      </Suspense> */}

        {/* Optionally, display more hotels with AllInclusiveHotelCard */}
        {/* <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
        {topRowHotels.map((hotel) => (
          <Suspense fallback={<Loader />} key={hotel._id}>
            <LazyAllInclusiveHotelCard hotel={hotel} />
          </Suspense>
        ))}
      </div> */}
      </section>
    </>
  );
};

export default PageLastminute;
